import axios from '../utils/axios';
import API_ENDPOINTS from '../constants/api-endpoints';
import { useQuery, useMutation } from 'react-query';

export const useValidateToken = (options = {}) => {
    return useQuery([API_ENDPOINTS.USER_VALIDATE_TOKEN], () => axios.get(API_ENDPOINTS.USER_VALIDATE_TOKEN),
        {
            select: (data) => {
                window.localStorage.setItem('userInfo', JSON.stringify(data.data));
                return data.data
            },
            retry: false,
            refetchOnWindowFocus: false,
            initialData: () => ({ data: null }),
            ...options
        }
    );
};


export const useLogin = ({ onSuccess, onError }, others = {}) => {
    return useMutation((data) => axios.post(API_ENDPOINTS.USER_LOGIN, data), {
        select: (data) => data.data,
        onSuccess: (res) => {
            if (onSuccess && typeof onSuccess === 'function') {
                onSuccess(res);
            }
        },
        onError: (res) => {
            if (onError && typeof onError === 'function') {
                onError(res);
            }
        },
        ...others
    });
}



export const useAdminUpdateProfile = ({ onSuccess, onError }, others = {}) => {
    return useMutation((data) => axios.post(API_ENDPOINTS.USER_UPDATE_PROFILE, data), {
        select: (data) => data.data,
        onSuccess: (res) => {
            if (onSuccess && typeof onSuccess === 'function') {
                onSuccess(res);
            }
        },
        onError: (res) => {
            if (onError && typeof onError === 'function') {
                onError(res);
            }
        },
        ...others
    });
}
export const useAdminUpdatePassword = ({ onSuccess, onError }, others = {}) => {
    return useMutation((data) => axios.post(API_ENDPOINTS.USER_UPDATE_PASSWORD, data), {
        select: (data) => data.data,
        onSuccess: (res) => {
            if (onSuccess && typeof onSuccess === 'function') {
                onSuccess(res);
            }
        },
        onError: (res) => {
            if (onError && typeof onError === 'function') {
                onError(res);
            }
        },
        ...others
    });
}